import { BenefitDaum } from 'all-in-one-shared-api/dist/apis/policy/useLifePolicyDetail';
import { changeDataFun } from 'utils/formate';
import { BeneficiariesDaum } from 'all-in-one-shared-api/dist/apis/policy/useLifePolicyDetail';

export interface BenefitDaumProps extends BenefitDaum {
  basicPlanDescTitle: string;
  benefitCurrDescTitle: string;
  benefitProductDescTitle: string;
  paymentModeDescTitle: string;
  premiumCurrDescTitle: string;
  premiumCDate?: string;
}

export const formatBenefit = (
  benefits: BenefitDaum[] | undefined,
  isEnglish: boolean,
  //   token: string,
): BenefitDaumProps[] | undefined => {
  if (!benefits) return undefined;
  const formattedBenefits = benefits.map((benefit) => {
    const {
      basicPlanDesc,
      basicPlanDescTc,
      benefitCurrDesc,
      benefitCurrDescTc,
      benefitProductDesc,
      benefitProductDescTc,
      paymentModeDesc,
      paymentModeDescTc,
      premiumCurrDesc,
      premiumCurrDescTc,
      premiumCessationDate,
    } = benefit;
    return {
      ...benefit,
      basicPlanDescTitle: isEnglish ? basicPlanDesc : basicPlanDescTc,
      benefitCurrDescTitle: isEnglish ? benefitCurrDesc : benefitCurrDescTc,
      benefitProductDescTitle: isEnglish ? benefitProductDesc : benefitProductDescTc,
      paymentModeDescTitle: isEnglish ? paymentModeDesc : paymentModeDescTc,
      premiumCurrDescTitle: isEnglish ? premiumCurrDesc : premiumCurrDescTc,
      premiumCDate: isEnglish ? premiumCessationDate : changeDataFun(premiumCessationDate),
    };
  });
  // Note(Andy Chow): The news fetched from api is already ordered by Mesg_Priority. Maximum 5 news according to https://generali-hk.atlassian.net/browse/AIOBRB-1647
  return formattedBenefits;
};

export interface BeneficiariesProps extends BeneficiariesDaum {
  roleDescTitle: string;
  relationshipDescTitle: string;
}
export const formatBeneficiaries = (
  beneficiaries: BeneficiariesDaum[] | undefined,
  isEnglish: boolean,
  //   token: string,
): BeneficiariesProps[] | undefined => {
  if (!beneficiaries) return undefined;
  const formattedBeneficiaries = beneficiaries.map((beneficiary) => {
    const { roleDesc, roleDescTc, relationshipDesc, relationshipDescTc } = beneficiary;
    return {
      ...beneficiary,
      roleDescTitle: isEnglish ? roleDesc : roleDescTc,
      relationshipDescTitle: isEnglish ? relationshipDesc : relationshipDescTc,
    };
  });
  // Note(Andy Chow): The news fetched from api is already ordered by Mesg_Priority. Maximum 5 news according to https://generali-hk.atlassian.net/browse/AIOBRB-1647
  return formattedBeneficiaries;
};
